/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'company-hub.section-extension.config-panel.background-color-field.background-color': 'Hintergrundfarbe',
  'company-hub.section-extension.config-panel.content-width-field.full-label': 'Vollständig',
  'company-hub.section-extension.config-panel.content-width-field.full-tooltip': 'Maximale Breite',
  'company-hub.section-extension.config-panel.content-width-field.label': 'Inhaltsbreite',
  'company-hub.section-extension.config-panel.content-width-field.narrow-label': 'Schmal',
  'company-hub.section-extension.config-panel.content-width-field.narrow-tooltip': 'Schmal',
  'company-hub.section-extension.config-panel.content-width-field.wide-label': 'Breit',
  'company-hub.section-extension.config-panel.content-width-field.wide-tooltip': 'Breit',
  'company-hub.section-extension.config-panel.preamble':
    'Fassen Sie Elemente zu anpassbaren Abschnitten zusammen. {supportLink}',
  'company-hub.section-extension.config-panel.preamble-link.label': 'Hier erfahren Sie mehr zum Gestalten Ihres Hubs.',
  'company-hub.section-extension.config-panel.preamble-without-support-link':
    'Fassen Sie zusammenhängende Elemente zu Abschnitten mit anpassbarem Hintergrund und Stil zusammen.',
  'company-hub.section-extension.config-panel.title': 'Abschnitt',
  'company-hub.section-extension.error-loading-content': 'Fehler beim Laden des Inhalts',
  'company-hub.section-extension.manifest.content.header': 'Abschnittstitel eingeben',
  'company-hub.section-extension.manifest.content.placeholder-title': 'Platzhalter',
  'company-hub.section-extension.manifest.content.sub-header':
    'Fassen Sie Elemente zu Abschnitten mit anpassbarem Hintergrund zusammen.',
  'company-hub.section-extension.manifest.extension-lozenge-title': 'Abschnitt',
  'company-hub.section-extension.manifest.extension-title': 'Abschnitt [Neu]',
  'company-hub.section-extension.manifest.macro-description': 'Gruppieren Sie Elemente mit einem Hintergrund.',
};
